import React, { Component } from 'react'
import { Col, Row, Label } from 'reactstrap'
import { observer } from 'mobx-react'
import Checkbox from '../../comum/components/Checkbox';
import FormInputSimples from '../../comum/components/FormInputSimples';
import Toggle from 'react-toggle';
import "react-toggle/style.css"
import LoadingImage from '../../comum/components/LoadingImage';
import lscache from "lscache"

@observer
export default class Notificacoes extends Component {

    constructor(props) {
        super(props);
        
        this.controller = this.props.controller;
    }

    handleUsarEmail = (enviar, id, email) => {
        if (enviar) {
            this.controller.setUsarEmail(enviar, id, email);
            // ideal: dentro de setUsarEmail o controller chamar salvarNotificacao(id)
        }
    }

    handleToggleEnviar = (id, enviarAtual) => {
        // só delega pro controller
        this.controller.setEnviar(id, enviarAtual);
        // ideal: dentro do setEnviar, depois de mudar o valor, o controller chamar salvarNotificacao(id)
    }

    handleSalvarEmail = (id) => {
        this.controller.salvarNotificacao(id);
    }

    render() {
        const c = this.controller;

        if (c.loadingNotificacoes) {
            return <LoadingImage />
        } else {
            return (
                <div className="px-3">
                    <Row>
                        {c.listaNotifTecon && c.notificacoesErro === ""
                            ? c.listaNotifTecon.map((dado, x) => {
                                return (
                                    <Col key={dado.Id} className="px-0" xs={12} sm={12} md={12} lg={6} xl={6}>
                                        <div className={dado.Enviar ? "card-detalhe notificacoes__card" : "card-detalhe notificacoes__card inativo"}>
                                            <div className="card-detalhe--conteudo">
                                                <Row className="w-100 px-3 mx-0 justify-content-between">
                                                    <h2 className={`pl-4 ml-4 ${dado.Enviar ? "" : "label-disabled"}`}>
                                                        {dado.TipoNotificDesc}
                                                    </h2>
                                                    <div style={{ marginTop: "12px" }}>
                                                        <Toggle
                                                            className="custom-toggle"
                                                            icons={false}
                                                            defaultChecked={dado.Enviar}
                                                            onChange={() => this.handleToggleEnviar(dado.Id, dado.Enviar)}
                                                        />
                                                    </div>
                                                </Row>

                                                {c.listaAlertaNotif[x] &&
                                                    <Row className="w-100 px-0 mb-0 d-flex justify-content-end">
                                                        <Label className="mb-1 label-primary mr-xl-3 mr-lg-3">
                                                            {c.listaAlertaNotif[x]}
                                                        </Label>
                                                    </Row>
                                                }

                                                <Row className="w-100 px-2 mb-0 justify-content-end">
                                                    <Col className="col-12">
                                                        {dado.DescDetalhe &&
                                                            <Label className="mb-1 ml-3 label-informacoes">
                                                                {dado.DescDetalhe}
                                                            </Label>
                                                        }
                                                    </Col>
                                                </Row>

                                                <Row className="mr-3 pl-4 align-items-end">
                                                    <Col xs={12} sm={9} md={9} lg={9} xl={9}>
                                                        <FormInputSimples
                                                            style={{ color: dado.Enviar ? "#3F3F3F" : "#B1BBC6" }}
                                                            xs={12} sm={12} md={12} lg={12} xl={12}
                                                            titulo="E-mail"
                                                            extraInfo={"Para inclusão de mais de um email, utilize separação por vírgula"}
                                                            extraInfoSmaller={true}
                                                            dado={dado.Email}
                                                            bloqueado={!dado.Enviar}
                                                            onChange={(event) =>
                                                                this.controller.setEmail(dado.Id, event.target.value)
                                                            }
                                                        />
                                                    </Col>

                                                    <Col xs={12} sm={3} md={3} lg={3} xl={3} className="mt-2 mt-md-4">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-sm"
                                                            disabled={!dado.Enviar || c.loadingNotificacoes}
                                                            onClick={() => this.handleSalvarEmail(dado.Id)}
                                                        >
                                                            Salvar e-mail
                                                        </button>
                                                    </Col>
                                                </Row>

                                                <Row className="pl-4 align-itens-center">
                                                    <div>
                                                        <Checkbox
                                                            className="pl-3 mx-0 mb-2"
                                                            ativo={dado.PegarEmailUsuarioLogado && dado.Enviar}
                                                            onClick={() => this.handleUsarEmail(dado.Enviar, dado.Id, dado.PegarEmailUsuarioLogado)}
                                                        />
                                                    </div>
                                                    <b className={
                                                        dado.Enviar
                                                            ? `ml-3 my-auto ${dado.PegarEmailUsuarioLogado ? "notif-email--ativo" : "notif-email--inativo"}`
                                                            : "ml-3 my-auto label-disabled"
                                                    }>
                                                        Usar e-mail do cadastro
                                                    </b>
                                                    {dado.PegarEmailUsuarioLogado && dado.Enviar &&
                                                        <Col className="mt-2" xs={12} md={6} lg={4}>
                                                            <Label className="label-black mt-1">
                                                                {lscache.get("Email")}
                                                            </Label>
                                                        </Col>
                                                    }
                                                </Row>
                                            </div>
                                        </div>
                                    </Col>
                                );
                            })
                            : <div><Label>{c.notificacoesErro}</Label></div>
                        }
                    </Row>
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/meutecon/components/Notificacoes.js